import toLower from 'lodash/toLower';
export function transformMe(user) {
    const { bannerImageUrl, imageUrl, userId, userName, firstName, lastName, isFollowingListPublic, isRegistered, subscriptions, email, } = user;
    const currentSub = subscriptions?.edges?.[0]?.node || {};
    return {
        content: {
            id: userName,
            accountId: userId,
            isFollowingListPublic,
            userName,
            bannerImage: bannerImageUrl,
            image: imageUrl,
            subtitle: userName,
            title: `${firstName} ${lastName}`,
            isRegisteredUser: isRegistered,
            subscriptionKey: currentSub.key,
            subscriptionProviderName: currentSub.providerName,
            subscriptionStatus: toLower(currentSub.status) || 'none',
            email,
        },
    };
}
